//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SPage from "~/components/page/SPage.vue";
import QuickAppointmentForm from "~/components/appointment/QuickAppointmentForm.vue";
import {AppMixin} from "~/node_modules/sitis-nuxt/lib/mixins";
import {CmsMetaMixin} from "~/node_modules/sitis-nuxt/lib/mixins/index";

export default {
    components: {
        SPage,
        QuickAppointmentForm,
    },
    mixins: [AppMixin, CmsMetaMixin],
    async asyncData({$api}) {
        const {data: services} = await $api.agent.transport.get("services");
        const {data: salons} = await $api.agent.transport.get("stores");
        const {data: specialists} = await $api.agent.transport.get(
          "specialist?expand=stores"
        );

        return {
            services,
            salons,
            specialists,
        };
    },
    data() {
        return {
            form: {
                service: "",
                salon: "",
                specialist: "",
            },

            breadcrumbs: [
                {
                    title: "Главная",
                    path: "/",
                },
                {
                    title: "Запись на приём",
                    path: "/zapis",
                },
            ],

            stage: 0,
            permittedStage: 0,
        };
    },
    methods: {
        changeForm({name, value}) {
            const newForm = {...this.form};
            newForm[name] = value;
            this.form = newForm;

            this.nextStage();
        },
        changeStage(stage) {
            this.stage = stage;
        },

      disableInput() {
        this.$refs.input.setAttribute('disabled', 'disabled');
        this.$refs.input.classList.add('disabled-opacity');
      },

        nextStage() {
            let stage = 0;

            if (this.form.service) {
                stage = 1;
            }
            if (this.form.salon) {
                stage = 2;
            }
            if (this.form.specialist) {
                stage = 3;
            }

            this.stage = stage;
            this.permittedStage = stage;
        },
    },
};
